<template>
  <div>
    <b-card>
      <b-row>
        <!-- 차트 정보 -->
        <b-col lg="12" xl="6">
          <b-row>
            <!-- 레이아웃조정용 -->
            <b-col md="2"></b-col>
            <b-col md="8" class="animated fadeIn fadeOut mt-2">
              <center>
                <label for="ph_count" v-b-tooltip.hover>Site Configuration Summary</label><br>
                <vue-apex-charts class="mt-5" ref="_list" :width="thumbnail_size" type="donut" :options="options" :series="data"></vue-apex-charts>
              </center>
            </b-col>
            <!-- 레이아웃조정용 -->
            <b-col md="2"></b-col>
          </b-row>
        </b-col>
        <!-- 간단한 요약 및 진행 정도 -->
        <b-col lg="12" xl="6">
          <b-card class="text-center" style="font-size:1.3em">
            <b-row>
              <b-col md="12">
                <b-button size="sm" block variant="info" @click="$emit('stop')"> Auto Refresh ({{refresh_timer}}) </b-button>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="ph_count" v-b-tooltip.hover>Started_at</label>
                  <hr>
                  <label for="ph_page">{{result.started_at | utcdatetime }} ~</label>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="ph_count" v-b-tooltip.hover>Inspection Progress Time</label>
                  <hr>
                  <b-badge variant="primary" v-if="result && result.started_at && moment().diff(result.started_at, 'minutes') > 0">
                    {{moment().diff(result.started_at, 'minutes')}} minutes ~
                  </b-badge>
                  <b-badge variant="primary" v-else>
                    Preparing..
                  </b-badge>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="ph_count" v-b-tooltip.hover>Status</label>
                  <hr>
                  <h4>
                    <b-badge :variant="codes.TEXT_COLORS[result.status%5]"> {{codes.WMDS_INSPECT_STATUS[result.status] ? codes.WMDS_INSPECT_STATUS[result.status].toUpperCase() : ''}} </b-badge>
                  </h4>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col md="12">
                <p>TICKET</p>
                {{result.guid}}
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col md="12">
                <p>Checking Page</p>
                <a target="_blank" :href="result.working_page" class="card-link">
                  <small><i class="fa fa-share"></i>  {{result.working_page}}</small>
                </a>
              </b-col>
            </b-row>
            <!-- 에이전트에서 준비 되면 진행바 표시 -->
            <!-- <hr>
            <b-row>
              <b-col md="12">
                <div class="progress">
                  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :aria-valuenow="total" aria-valuemin="0" :aria-valuemax="total * 1.5" style="width: 75%"></div>
                </div>
              </b-col>
            </b-row> -->
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment-timezone'
import codes from '@/codes'

export default {
  props: ['status', 'refresh_timer'],
  components: { VueApexCharts },
  watch : {
    status() {
      this.get()
    }
  },
  data : () => {
    return {
      codes,
      moment,
      total : 0,
      thumbnail_size: '100%',
      data: [],
      options: {
        labels: [],
        legend: { position: 'bottom', }
      },
      result : {},
    }
  },

  computed: {},
  methods: {
    get() {
      try {
        this.result = Object.assign({}, this.result, this.status)
        this.total = 0
        this.data = []
        this.options = Object.assign({}, this.options, { labels : [] })

        Object.keys(this.result).forEach(x => {
          try {
            if(x.endsWith("_qty")) {
              this.data.push(this.result[x])
              this.options.labels.push(x.replace("_qty", ''))
              this.total += this.result[x]
            }
          } catch (e) { console.error(e) }
        })

        if(this.total < 1) {
          this.data.push(100)
          this.options.labels.push('inspection failed')
        }

        this.$toastr.s("load Successful")
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) }
    },
  },
  // watch: { '$route' (to, from) { console.log("from", from) } },
  created() { console.log('result.detail.vue', 'created'); },
  destroyed() { console.log('result.detail.vue', 'destroyed'); },
  mounted() { console.log('result.detail.vue', 'mounted'); this.get(); },
}
</script>
